<template>
  <div class="new_pack_chip" :class="[variant]">
    <label class="font-family-1 regular-s f-w-600 t-black caps">{{
      compTitle
    }}</label>
    <!-- 
    <StarIcon2 class="bottom_star" />
    <StarIcon2 class="top_right_star" />
    <StarIcon2 class="bottom_right_star" /> -->

    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="bottom_star"
    >
      <path
        d="M7.60571 3.57476L7.05177 1.84887C6.89027 1.34569 6.43242 1.125 6.05335 1.125C5.67428 1.125 5.21643 1.34569 5.05493 1.84887L4.50099 3.57476C4.44465 3.75029 4.2911 3.91074 4.06481 3.97629L2.24809 4.50253C1.24282 4.79372 1.24282 6.20628 2.24809 6.49747L4.06481 7.02371C4.2911 7.08926 4.44465 7.24971 4.50099 7.42524L5.05493 9.15112C5.21643 9.65431 5.67428 9.875 6.05335 9.875C6.43242 9.875 6.89027 9.65431 7.05177 9.15112L7.60571 7.42524C7.66205 7.24971 7.8156 7.08926 8.04189 7.02371L9.85861 6.49747C10.8639 6.20628 10.8639 4.79372 9.85861 4.50253L8.04189 3.97629C7.8156 3.91074 7.66205 3.75029 7.60571 3.57476Z"
        fill="#050607"
      />
    </svg>

    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="top_right_star"
    >
      <path
        d="M7.60571 3.57476L7.05177 1.84887C6.89027 1.34569 6.43242 1.125 6.05335 1.125C5.67428 1.125 5.21643 1.34569 5.05493 1.84887L4.50099 3.57476C4.44465 3.75029 4.2911 3.91074 4.06481 3.97629L2.24809 4.50253C1.24282 4.79372 1.24282 6.20628 2.24809 6.49747L4.06481 7.02371C4.2911 7.08926 4.44465 7.24971 4.50099 7.42524L5.05493 9.15112C5.21643 9.65431 5.67428 9.875 6.05335 9.875C6.43242 9.875 6.89027 9.65431 7.05177 9.15112L7.60571 7.42524C7.66205 7.24971 7.8156 7.08926 8.04189 7.02371L9.85861 6.49747C10.8639 6.20628 10.8639 4.79372 9.85861 4.50253L8.04189 3.97629C7.8156 3.91074 7.66205 3.75029 7.60571 3.57476Z"
        fill="#050607"
      />
    </svg>
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="bottom_right_star"
    >
      <path
        d="M7.60571 3.57476L7.05177 1.84887C6.89027 1.34569 6.43242 1.125 6.05335 1.125C5.67428 1.125 5.21643 1.34569 5.05493 1.84887L4.50099 3.57476C4.44465 3.75029 4.2911 3.91074 4.06481 3.97629L2.24809 4.50253C1.24282 4.79372 1.24282 6.20628 2.24809 6.49747L4.06481 7.02371C4.2911 7.08926 4.44465 7.24971 4.50099 7.42524L5.05493 9.15112C5.21643 9.65431 5.67428 9.875 6.05335 9.875C6.43242 9.875 6.89027 9.65431 7.05177 9.15112L7.60571 7.42524C7.66205 7.24971 7.8156 7.08926 8.04189 7.02371L9.85861 6.49747C10.8639 6.20628 10.8639 4.79372 9.85861 4.50253L8.04189 3.97629C7.8156 3.91074 7.66205 3.75029 7.60571 3.57476Z"
        fill="#050607"
      />
    </svg>
  </div>
</template>

<script setup>
import StarIcon2 from "../icons/StarIcon2.vue";
const { t } = useI18n();
const props = defineProps({
  currentGameSlug: {
    default: "",
  },

  variant: {
    default: "green",
  },

  title: {
    default: "",
  },
});

const compTitle = computed(() => {
  if (props.title) {
    return props.title;
  }

  return t("app.new");
});
</script>
